import { regex } from "./Regex";

export const validateBordereauForm = (
  form: { [key: string]: string | number | null | string[]},
  mode: "create" | "edit" | "full",
  isAdminOrMagasinLoin: boolean,
  setError: (msg: string) => void
): boolean => {
  const requiredFields: [keyof typeof form, string, RegExp][] = [
    ["destinataire", "Client invalide.", regex.namestring],
    ["bon", "Bon invalide.", regex.namestring],
    ["datelivraison", "Date livraison invalide.", regex.dateRegex]
  ];

  const extendedFields: [keyof typeof form, string, RegExp][] = [
    ["livreur", "Livreur invalide.", regex.namestring],
    ["vehicule", "Véhicule invalide.", regex.namestring],
    ["chaffeur", "Chauffeur invalide.", regex.namestring],
    ["telephone", "Téléphone invalide.", regex.teleregex],
    ["cooperative", "Coopérative invalide.", regex.namestring],
  ];

  const fieldsToValidate = [...requiredFields, ...(mode !== "create" && isAdminOrMagasinLoin ? extendedFields : [])];

  for (const [key, message, pattern] of fieldsToValidate) {
    const value = form[key];
    const strValue = value !== null && value !== undefined ? String(value).trim() : "";
    if(key==="telephone"){
      if(strValue && !regex.teleregex.test(strValue)){
        setError(message);
        return false;
      }
    }else{
      if (!strValue || !pattern.test(strValue)) {
        setError(message);
        return false;
      }
    }

  }

  return true;
};
